
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanInterface } from '@/services/Plan/interfaces';

@Component
export default class EditPlanDialog extends Vue {
  @Prop() public plan!: PlanInterface;

  public newPlanName: string = '';

  public quota: number = 0;

  public bandwidth: number = 0;

  public websiteCount: number = 1;

  public visible: boolean = true;

  public get valid(): boolean {
    return this.newPlanName.trim() !== '' && this.newPlanName.length > 2 && !!this.quota;
  }

  public created(): void {
    this.newPlanName = this.plan.name;
    this.quota = this.plan.quota;
    this.bandwidth = this.plan.bandwidth;
    this.websiteCount = this.plan.websitesCount;
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }

  public async editPlan(): Promise<void> {
    this.$emit('editPlan', this.plan.id, this.newPlanName, this.quota, this.bandwidth, this.websiteCount);
    this.destroyComponent();
  }
}
